import { render, staticRenderFns } from "./snailVideoDetail.vue?vue&type=template&id=bc5db958&scoped=true&"
import script from "./snailVideoDetail.vue?vue&type=script&lang=js&"
export * from "./snailVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./snailVideoDetail.vue?vue&type=style&index=0&id=bc5db958&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5db958",
  null
  
)

export default component.exports